var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEmailSettings = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 22,
  height: 22,
  viewBox: "0 0 22 22"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M19.498,19 C20.328,19 21,18.328 21,17.499 L21,4.502 C21,3.672 20.327,3 19.498,3 L2.502,3 C1.672,3 1,3.672 1,4.501 L1,7.618 L11,12.118 L16.447,8.895 C16.941,8.647 17.142,8.047 16.894,7.553 C16.646,7.059 16.047,6.858 15.553,7.105 L11,9.882 L3,6.382 L3,5 L19,5 L19,17 L4,17 C3.448,17 3,16.551 3,16 L3,12 C3,11.448 2.553,11 2,11 C1.447,11 1,11.448 1,12 L1,16 C1,17.654 2.346,19 4,19 L19.498,19 Z"
})));
export default SvgEmailSettings;